import {Content} from '@prismicio/client'
import {SliceComponentProps} from '@prismicio/react'
import {Context} from 'src/common/types'
import {FooterNoNavDefault} from './Default'
import {FooterNoNavV2} from './V2'

/**
 * Props for `FooterNoNav`.
 */
export type FooterNoNavProps = SliceComponentProps<Content.FooterNoNavSlice> & {context: Context}

/**
 * Component for "FooterNoNav" Slices.
 */
const FooterNoNav = ({slice, context: {navigation_data}}: FooterNoNavProps) => {
  switch (slice.variation) {
    case 'v2':
      return <FooterNoNavV2 navigationData={navigation_data} />
    case 'default':
      return <FooterNoNavDefault navigationData={navigation_data} />
    default:
      return null
  }
}

export default FooterNoNav
